/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { Component } from '@appCanvasCommon/component-system/Component';
import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { CanvasAngularLand } from '../../../../app-data/interfaces/canvas-angular-land';
import { AbstractApplication } from '@appCanvasCommon/core/AbstractApplication';
import { TicketPlanApplication } from '@appPlanApplication/TicketPlanApplication';
/**
 * This export component disables/enables all ticket container interaction when the export is in Edit mode
 */
export class HandleTicketInteraction extends Component implements ComponentInterface {
	/**
	 * Invoked once the lightbox is first created
	 * @param canvasAngularLand
	 * @param application
	 */
	public onExportPreviewStarted(
		canvasAngularLand: CanvasAngularLand,
		application: AbstractApplication
	): void {
		const ticketSpaceApplication: TicketPlanApplication = application as TicketPlanApplication;
		if (ticketSpaceApplication.ticketManager) {
			ticketSpaceApplication.ticketManager.disableAllTicketInteraction();
		}
	}
	/**
	 * Invoked once the export is finished
	 * @param canvasAngularLand
	 * @param application
	 */
	public onExportPreviewClosed(canvasAngularLand: CanvasAngularLand, application: AbstractApplication): void {
		const ticketSpaceApplication: TicketPlanApplication = application as TicketPlanApplication;
		if (ticketSpaceApplication.ticketManager) {
			ticketSpaceApplication.ticketManager.enableAllTicketInteraction();
		}
	}
}
